import React from 'react';
import { cn } from '../../lib/utils';

/**
 * ShineBorder – Animasyonlu gradient kenarlıklı sarmalayıcı
 * @param {React.ReactNode} children
 * @param {string} [className]
 * @param {number} [borderWidth=2]
 * @param {number} [duration=3]
 * @param {string} [gradient] – "from-blue-500 via-red-500 to-teal-400" gibi Tailwind sınıfları veya boş (varsayılan renkler kullanılır)
 */
const ShineBorder = ({
  children,
  className,
  borderWidth = 2,
  duration = 3,
  gradient = 'from-blue-500 via-red-500 to-teal-400',
}) => {
  const gradientColors = {
    'from-blue-500 via-red-500 to-teal-400': 'conic-gradient(from 0deg, #3b82f6, #ef4444, #2dd4bf)',
    'from-blue-500 via-cyan-500 to-teal-400': 'conic-gradient(from 0deg, #3b82f6, #06b6d4, #2dd4bf)',
    'from-primary via-red-500 to-teal-400': 'conic-gradient(from 0deg, var(--primary), #ef4444, #2dd4bf)',
  };
  const conicGradient =
    gradientColors[gradient] ||
    'conic-gradient(from 0deg, #3b82f6, #ef4444, #2dd4bf)';

  return (
    <div
      className={cn('relative rounded-2xl h-full flex flex-col', className)}
      style={{ padding: borderWidth }}
    >
      <div className="absolute inset-0 overflow-hidden rounded-2xl">
        <div
          className="absolute -inset-[100%] animate-spin blur-sm"
          style={{
            animationDuration: `${duration}s`,
            background: conicGradient,
          }}
        />
      </div>
      <div className="relative flex-1 min-h-0 flex flex-col rounded-2xl bg-card">{children}</div>
    </div>
  );
};

export { ShineBorder };
